import { SHIPPING_PROVIDER } from "@dransay/api/models";

export const ShippingProviderLabel = {
	[SHIPPING_PROVIDER.DHL_STANDARD]: "DHL Standard",
	[SHIPPING_PROVIDER.DHL_EXPRESS]: "DHL Express",
	[SHIPPING_PROVIDER.GO]: "Go",
	[SHIPPING_PROVIDER.HERMES]: "Hermes",
	[SHIPPING_PROVIDER.GLS]: "GLS",
	[SHIPPING_PROVIDER.FEDEX]: "FedEx",
	[SHIPPING_PROVIDER.UPS]: "UPS",
} as const;
